import { render, staticRenderFns } from "./ConnectMethod.vue?vue&type=template&id=532d9127&"
import script from "./ConnectMethod.vue?vue&type=script&lang=js&"
export * from "./ConnectMethod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports